import { useMemo } from 'react';
import { SpreadsheetConfig } from 'components/ScalarSpreadsheet/utilities/SpreadsheetConfig';
import { WaterfallFundSummaryRowConfig } from 'pages/Waterfall/SpreadsheetConfig/FundSummarySheetConfig/FundSummaryRowConfig/WaterfallFundSummaryRowConfig';
import {
  WATERFALL_FUND_SUMMARY_COLUMNS,
  WATERFALL_FUND_SUMMARY_COLUMNS_WITH_LOAN,
} from 'pages/Waterfall/SpreadsheetConfig/FundSummarySheetConfig/useFundSummarySheetConfig/UseWaterfallFundSummarySheetConfig.constants';
import { UseWaterfallFundSummarySheetConfigProps } from 'pages/Waterfall/SpreadsheetConfig/FundSummarySheetConfig/useFundSummarySheetConfig/useWaterfallFundSummarySheetConfig.props';
import { waterfallFundSummaryParser } from 'pages/Waterfall/SpreadsheetConfig/FundSummarySheetConfig/WaterfallFundSummaryParser/WaterfallFundSummaryParser';

export const useWaterfallFundSummarySheetConfig = ({ captable, fundList, childrenCompanies, calculatedEquityValue, fundIrrMap }: UseWaterfallFundSummarySheetConfigProps) => {
  const hasLoanValues = useMemo(() => {
    if (!captable) return false;
    return (captable.fund_ownership?.fund_ownership_detail ?? []).some(
      d => Number(d.loan_value ?? '0') > 0
    );
  }, [captable]);

  const rowConfig = useMemo(() => {
    if (!captable || !calculatedEquityValue) {
      return [];
    }
    return WaterfallFundSummaryRowConfig({ captable, fundIrrMap });
  }, [captable, calculatedEquityValue, fundIrrMap]);

  const tableData = useMemo(
    () => {
      if (captable) {
        return ({
          fundList,
          childrenCompanies,
          captable
        });
      }
    },
    [fundList, childrenCompanies, captable]
  );

  const sheetConfig = useMemo(() => {
    if (rowConfig) {
      return new SpreadsheetConfig({
        name: 'waterfallFundSummary',
        showTitlesColumn: false,
        reverseParser: undefined,
        tableData,
        columns: hasLoanValues ? WATERFALL_FUND_SUMMARY_COLUMNS_WITH_LOAN : WATERFALL_FUND_SUMMARY_COLUMNS,
        rowConfig,
        parser: waterfallFundSummaryParser,
      });
    }
    return null;
  }, [rowConfig, tableData, hasLoanValues]);

  return {
    sheetConfig,
  };
}